import { Card, CardContent, CardHeader, useMediaQuery } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

//import custom components
import componentStylesGeneric from "assets/theme/views/admin/generic.js";
import GenericButton from "components/Buttons/GenericButton";
import FormDropdown from "components/FormFields/FormDropdown";
import FormInputV2 from "components/FormFields/FormInputV2";
import { useDataset } from "hooks/useDataset";
import { DATASET } from "utils/const";
import { getKeyValueByCode } from "utils/datasets";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const FilterSection = ({ sortColumn, sortDirection, isLoading = false, onSearch, onClear }) => {
  const classes = useStylesGeneric();
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  const { handleSubmit, control, watch } = useFormContext();

  const { data: PROVINCES } = useDataset({ name: DATASET.PROVINCES });

  const provinceId = watch("provinceId");
  const provinceKeyValue = useMemo(() => getKeyValueByCode(PROVINCES, provinceId), [PROVINCES, provinceId]);

  const { data: MUNICIPALITIES } = useDataset(
    { name: DATASET.MUNICIPALITIES, parentKeyValue: provinceKeyValue },
    {
      enabled: !!provinceKeyValue,
    }
  );

  const { data: ECONOMIC_ACTIVITIES_CLASSIFICATION } = useDataset({ name: DATASET.ECONOMIC_ACTIVITIES_CLASSIFICATION });

  const onSubmit = async () => {
    await onSearch?.({ sortColumn, sortDirection });
  };

  const handleClearFilters = async () => {
    await onClear?.({ sortColumn, sortDirection });
  };

  return (
    <Card classes={{ root: classes.cardRoot }}>
      <CardHeader
        classes={{
          action: classes.cardHeaderAction,
          title: classes.cardHeader,
        }}
        title={
          <Grid container>
            <Box>Pesquisa de Centros de Trabalho</Box>
          </Grid>
        }
      />
      <CardContent>
        <Box>
          <Grid container classes={{ root: classes.containerPadding }}>
            <Grid item xs={12} sm={6} md={4}>
              <FormInputV2 name="name" label="Nome do Centro" placeholder="Insira o nome do centro" control={control} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormDropdown name="provinceId" label="Província" control={control} options={PROVINCES} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormDropdown
                name="municipalityId"
                label="Município"
                control={control}
                options={MUNICIPALITIES}
                disabled={!provinceId}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <FormDropdown
                name="secondaryActivityId"
                label="Actividade"
                control={control}
                options={ECONOMIC_ACTIVITIES_CLASSIFICATION}
              />
            </Grid>

            <Grid item xs={12} md={12} classes={{ root: classes.textAlignRight }}>
              <Box
                display="flex"
                justifyContent={isSmDown ? "stretch" : "flex-end"}
                alignItems={isSmDown ? "stretch" : "center"}
                flexDirection={isSmDown ? "column" : "row"}
                gridGap={12}
              >
                <GenericButton
                  type="button"
                  color="ghost"
                  onClick={handleClearFilters}
                  fullWidth={isSmDown}
                  size={isSmDown ? "medium" : undefined}
                >
                  Limpar Filtros
                </GenericButton>
                <GenericButton
                  type="button"
                  color="primary"
                  loading={isLoading}
                  onClick={handleSubmit(onSubmit)}
                  fullWidth={isSmDown}
                  size={isSmDown ? "medium" : undefined}
                >
                  Pesquisar
                </GenericButton>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FilterSection;
